import { render, staticRenderFns } from "./CategorySelect.vue?vue&type=template&id=64ee96a2&scoped=true&"
import script from "./CategorySelect.vue?vue&type=script&lang=js&"
export * from "./CategorySelect.vue?vue&type=script&lang=js&"
import style0 from "./CategorySelect.vue?vue&type=style&index=0&id=64ee96a2&prod&scoped=true&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ee96a2",
  null
  
)

export default component.exports